'use strict';

var Chat = {
  open: function (event) {
    event.preventDefault();
    var URL =
      $(this).data('chat') || 'https://www12.directtalk.com.br/chat31/?idd=00DF009021F720173351';
    window.open(
      URL,
      'janela',
      'width=520, height=550, top=99, left=99, scrollbars=no, status=no, toolbar=no, location=no, directories=no, menubar=no, resizable=no, fullscreen=yes'
    );
  }
};

$('.js-chat').on('click tap', Chat.open);
